import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, Row, Col, Layout, Card, message } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  AppstoreOutlined, UserOutlined
} from '@ant-design/icons';
import efn from './UserLogicFns'
import './SignUp.scss';
const { Title, Text } = Typography;
function ResetPwd(props) {
  const [isLogining, setIsLogining] = useState(false)
  const navigate = useNavigate()
  const location = useLocation();
  const setFuncMap = {
    setIsLogining, ...props.setFuncMap
  }
  const onFinish = (values) => {
    efn.resetUserPwd(values, setFuncMap, {
      navigate, location
    })
  };
  return (
    <div className="ResetPwd">
      <Layout>
        <Row justify="center" align="middle">
          <Col span={24}>
            <Card style={{ borderRadius: '8px', display: "flex", flexDirection: "column" }}>
              <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>ICEI Reset Password</Title>
              <Form
                name="google_login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                layout="horizontal"
              >
                {generateResetPwdAttribute().map((item, key) => {
                  return <Form.Item key={key}
                    name={item.name}
                    label={item.label}
                    rules={[{ required: item.required, message: `請輸入${item.label}` }, ...item.rules]}
                  >
                    {item.type === "text" && <Input placeholder={item.label} size="large" />}
                    {item.type === "pwd" && <Input.Password placeholder={item.label} size="large" />}
                  </Form.Item>
                })}
                <div></div>
                <Form.Item>
                  <Row gutter={16} justify={'space-around'}>
                    <Col>
                      <Button loading={isLogining} type="primary" htmlType="submit" style={{ background: "#fea4a4" }} size="large">
                        Update
                      </Button>
                    </Col>
                    <Col>
                      <Button size="large" onClick={() => { navigate(location.pathname) }}>
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Layout>
    </div>
  );
}

const generateResetPwdAttribute = function () {
  return [{
    label: "舊密碼",
    type: "pwd",
    name: "oldPwd",
    required: true,
    rules: []
  },
  {
    label: "密碼",
    type: "pwd",
    name: "pwd",
    required: true,
    rules: []
  },
  {
    label: "密碼確認",
    type: "pwd",
    name: "pwd_check",
    required: true,
    rules: [({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue('pwd') === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('The two passwords do not match!'));
      },
    }),]
  }]
}

export default ResetPwd;
